import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { API } from "../../utils/Api";

export const fetchOrders = createAsyncThunk(
    "orders/fetchOrders",
    async ({ allOrdersSort = "true", ordersType = "ALL" }, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem("token");

            const today = new Date();
            const y = today.getFullYear();
            const m = String(today.getMonth() + 1).padStart(2, "0");
            const d = String(today.getDate()).padStart(2, "0");

            const year = today.getFullYear();
            const month = (today.getMonth() + 1).toString().padStart(2, '0');
            const day = today.getDate().toString().padStart(2, '0');
            const formattedDate = `${year}-${month}-${day}`;

            const tomorrow = new Date(today);
            tomorrow.setDate(today.getDate() + 1);

            const ty = tomorrow.getFullYear();
            const tm = String(tomorrow.getMonth() + 1).padStart(2, "0");
            const td = String(tomorrow.getDate()).padStart(2, "0");

            const startBusinessDay = `${y}-${m}-${d}T06:00:00`;
            const endBusinessDay = `${ty}-${tm}-${td}T05:59:59`;

            // let url = `${API.BASE_URL}outlet/orders?allOrders=${allOrdersSort}&startBusinessDay=${startBusinessDay}&endBusinessDay=${endBusinessDay}`;
            // let url = `${API.BASE_URL}outlet/orders?allOrders=${allOrdersSort}&fromDate=${formattedDate}&toDate=${formattedDate}`;
            // let url = `${API.BASE_URL}outlet/orders?allOrders=${allOrdersSort}&fromDate=2026-04-05&toDate=2026-04-05`;
            let url = `${API.BASE_URL}outlet/orders?allOrders=${allOrdersSort}&limit=50`;

            if (ordersType !== "ALL") {
                url += `&ordersType=${ordersType}`;
            }

            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            console.log("response", response);

            return response?.data?.data?.orders || [];
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const ordersSlice = createSlice({
    name: "orders",
    initialState: {
        orders: [],
        loading: false,
        error: null,
        hasNewOrder: false,
    },
    reducers: {
        setOrders: (state, action) => {
            state.orders = action.payload;
        },

        clearOrders: (state) => {
            state.orders = [];
        },

        setHasNewOrder: (state, action) => {
            state.hasNewOrder = action.payload;
        },

        addSocketOrder: (state, action) => {
            const newOrder = action.payload;

            const exists = state.orders.some(
                (order) => order._id === newOrder._id
            );

            if (!exists) {
                state.orders.unshift(newOrder);
            }

            state.hasNewOrder = true;
        },

        updateSocketOrder: (state, action) => {
            const updatedOrder = action.payload;

            const index = state.orders.findIndex(
                (order) => order._id === updatedOrder._id
            );

            if (index !== -1) {
                state.orders[index] = {
                    ...state.orders[index],
                    ...updatedOrder,
                };
            }
        },

        removeSocketOrder: (state, action) => {
            const orderId = action.payload;

            state.orders = state.orders.filter(
                (order) => order._id !== orderId
            );
        },
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchOrders.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchOrders.fulfilled, (state, action) => {
                state.loading = false;
                state.orders = action.payload;
            })
            .addCase(fetchOrders.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const {
    setOrders,
    clearOrders,
    setHasNewOrder,
    addSocketOrder,
    updateSocketOrder,
    removeSocketOrder,
} = ordersSlice.actions;

export default ordersSlice.reducer;